import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import Container from '@material-ui/core/Container';
import Avatar from '@material-ui/core/Avatar';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import {googleSiteKey, post} from './procedures';

class OneTimeLogin extends React.Component  {
    constructor(props) {
        super(props);

        this.state = {httpd_username: ''};
        this.state = {recaptchaRef: React.createRef()};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    getHttpdUsername(pathname){
        const slash = '/';
        var i = pathname.length - 1;
        while (i >= 0) {
            if (pathname[i] == slash ) {
                break
            }else{
                i--
            }
        }

        if (pathname[i] == slash ) {
            return pathname.substr(i + 1, pathname.length - i - 1);
        } else {
            return ''
        }
    }

    handleSubmit(event) {
        const httpdusername = this.getHttpdUsername( this.props.pathname );
        this.setState( {httpd_username: httpdusername});
        this.state.recaptchaRef.current.execute();
    }

    handleLogin() {
        const recaptchaValue = this.state.recaptchaRef.current.getValue();

        var obj_tosend={};
        obj_tosend.action = 'onetimelogIn';
        obj_tosend.g_recaptcha_response = recaptchaValue;
        obj_tosend.httpd_username = this.state.httpd_username;

        post('../tokensignin.php', obj_tosend);
    }

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <LockOpenOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Одноразовый вход
                    </Typography>
                    <form className={this.props.classes.form} noValidate>
                        <Grid container alignItems="center" className={this.props.classes.submitgrid}>
                            <Grid item xs>
                                <Button
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    className={this.props.classes.submit}
                                    onClick={this.handleSubmit}
                                >
                                    Войти в личный кабинет
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                        <div className={this.props.classes.linkCenter}>
                            <Link href="../" variant="body2">
                                Перейти на заглавную страницу
                            </Link>
                        </div>

                        <ReCAPTCHA ref={this.state.recaptchaRef}
                                   sitekey={googleSiteKey}
                                   size="invisible"
                                   onChange = {this.handleLogin}
                        />
                    </form>
                </div>
            </Container>

        )

    }
}

export default OneTimeLogin;